// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3VqBu","large":"styles_large__3OebO"};